import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createTextVNode as _$ct, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Icon } from '../icon';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
var _$tmp0 = {
  'attributeName': 'opacity',
  'begin': '0s',
  'dur': '2s',
  'repeatCount': 'indefinite',
  'from': '0.2',
  'to': '0'
};
var _$tmp1 = {
  'viewBox': '0 0 120 120'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, r, circumference, icon, _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    type = _this$get.type,
    className = _this$get.className,
    percent = _this$get.percent,
    size = _this$get.size,
    showOuterText = _this$get.showOuterText,
    showInnerText = _this$get.showInnerText,
    strokeWidth = _this$get.strokeWidth,
    children = _this$get.children;
  var k = this.config.k;
  var status = this.status.value;
  var background = this.color.value || '';
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-progress"] = true, _classNameObj[k + "-" + type] = type, _classNameObj[className] = className, _classNameObj[k + "-" + status] = status !== 'normal', _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [type === 'bar' ? _$ce(2, 'div', _$ce(2, 'div', _$ce(2, 'div', showInnerText ? _$ce(2, 'div', [percent, _$ct(' %\n                ')], 0, _$cn(k + "-progress-inner-text")) : undefined, 0, _$cn(k + "-progress-bg"), {
    'style': {
      width: percent + '%',
      background: background
    }
  }), 2, _$cn(k + "-progress-content")), 2, _$cn(k + "-progress-container")) : undefined, type === 'circle' ? _$ce(512, 'svg', (r = (120 - strokeWidth) / 2, circumference = 2 * Math.PI * r, [_$ce(2, 'circle', null, 1, _$cn(k + "-progress-meter"), {
    'cx': '60',
    'cy': '60',
    'r': r,
    'stroke-width': strokeWidth
  }), _$ce(2, 'circle', null, 1, _$cn(k + "-progress-value"), {
    'cx': '60',
    'cy': '60',
    'r': r,
    'stroke-dashoffset': circumference * (1 - percent / 100),
    'stroke-dasharray': circumference,
    'stroke-width': strokeWidth
  }), status === 'active' ? _$ce(2, 'circle', [_$ce(2, 'animate', null, 1, null, {
    'attributeName': 'stroke-dashoffset',
    'begin': '0s',
    'dur': '2s',
    'repeatCount': 'indefinite',
    'from': circumference,
    'to': circumference * (1 - percent / 100)
  }), _$ce(2, 'animate', null, 1, null, _$tmp0)], 4, _$cn(k + "-progress-animate"), {
    'cx': '60',
    'cy': '60',
    'r': r,
    'stroke-width': strokeWidth,
    'stroke-dasharray': circumference,
    'stroke-dashoffset': circumference
  }) : undefined]), 0, _$cn(k + "-progress-canvas"), _$tmp1) : undefined, children ? _$ce(2, 'div', children, 0, _$cn(k + "-progress-text")) : showOuterText ? _$ce(2, 'div', function () {
    if (type !== 'circle') {
      switch (status) {
        case 'success':
          icon = [k + "-icon-success-fill"];
          break;
        case 'error':
          icon = [k + "-icon-error-fill"];
          break;
        case 'warning':
          icon = [k + "-icon-warning-fill"];
          break;
        default:
          break;
      }
    } else {
      switch (status) {
        case 'success':
          icon = [k + "-icon-check"];
          break;
        case 'error':
        case 'warning':
          icon = [k + "-icon-close"];
          break;
        default:
          break;
      }
    }
    if (icon) {
      return _$cc(Icon, {
        'className': _$cn((_$cn2 = {}, _$cn2[k + "-progress-icon"] = true, _$cn2[icon] = true, _$cn2)),
        'color': status === 'error' ? 'danger' : status
      });
    } else {
      return _$ce(2, 'span', [percent, _$ct('%')], 0);
    }
  }(), 0, _$cn(k + "-progress-text")) : undefined]);
}
;